export const TYPE_CONFORMITE = 'conformite';
export const TYPE_VPT = 'vpt';
export const TYPE_VE = 've';

export const DEFAULT_RESPONSE_REQUEST = 201;
export const DEFAULT_GET_RESPONSE_REQUEST = 200;

export const CONTROL_OF_WORK_POMPES = 'Pompes';
export const CONTROL_OF_WORK_VORTEX = 'Vortex';
export const CONTROL_OF_WORK_SIPHON = 'Effet siphon';
export const CONTROL_OF_WORK_FLOTTEUR = 'A flotteur';
export const CONTROL_OF_WORK_ORIFICE = 'Orifice / Plaque';
export const CONTROL_OF_WORK_CRAPAUDINES = 'Crapaudines';
export const CONTROL_OF_WORK_INFILTRATION = 'Infiltration';

export const VALUE_TRUE = 1;
export const VALUE_YES = 'oui';
export const VALUE_OTHER = 'autre';
export const VALUE_NO = 'non';
export const PROPERTY_VALUE_OTHERS = 'Autres';
export const NETWORK_VALUE_EP = 'Eaux pluviales';
export const CONNECTED_PARTALLY = 'partiellement';
